import { useState } from "react";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import { albumStore } from "../store";

type UseAlbumListMenuScrollProps = {
  loadMore?: () => Promise<any>;
  hasMore?: boolean;
  triggerOnNoScroll?: boolean;
};
export function useAlbumListMenuScroll(props?: UseAlbumListMenuScrollProps) {
  const hasMore = props?.hasMore ?? albumStore.albumsPageIdx < albumStore.albumsMaxPage;

  const [loadingMore, setLoadingMore] = useState(false);
  const scrollContainerRef = useBottomScrollListener(
    () => {
      if (!hasMore) return;
      if (loadingMore) return;

      setLoadingMore(true);
      if (props?.loadMore) {
        props.loadMore().finally(() => {
          setLoadingMore(false);
        });
      }
      albumStore.fetchAlbums(true).finally(() => {
        setLoadingMore(false);
      });
    },
    {
      offset: 1,
      debounce: 800,
      triggerOnNoScroll: props?.triggerOnNoScroll,
    },
  );

  return {
    scrollContainerRef,
    hasMore,
    loadingMore,
  };
}
